import { DatePipe } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SharedFeaturesService {
  durationInSeconds: number = 5;
  constructor(private injector: Injector, private datePipe: DatePipe) {}

  openSnackBar(message: string, action: string, styleClass: string) {
    const snackBarDuration =
      styleClass === 'success-snackbar'
        ? this.durationInSeconds * 1000
        : undefined;
    const snackBar = this.injector.get(MatSnackBar);
    snackBar.open(message, action, {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: styleClass,
      duration: snackBarDuration,
    });
  }

  extractNodeId(str: string): any {
    const regex = /Node ID - (\d+)/;
    const match = regex.exec(str);
    if (match) {
      const value = parseInt(match[1]);
      return { nodeId: value };
    }
    return null;
  }

  areArraysEqual(array1: any[], array2: any[]): boolean {
    if (array1.length !== array2.length) {
      return false;
    }

    for (let i = 0; i < array1.length; i++) {
      const item1 = array1[i];
      const item2 = array2[i];

      // Check if the objects have the same keys and values
      if (!this.areObjectsEqual(item1, item2)) {
        return false;
      }
    }

    return true;
  }

  areObjectsEqual(obj1: any, obj2: any): boolean {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  }

  areAllValuesNonEmpty(obj: any): boolean {
    for (const key in obj) {
      if (obj[key] === '') {
        return false;
      }
    }
    return true;
  }

  convertErrorToString(data: any): any {
    return JSON.stringify(data);
  }

  areAllValuesEmpty(obj: any): boolean {
    for (const key in obj) {
      if (obj[key] !== '') {
        return false;
      }
    }
    return true;
  }

  findObjectInArray<T>(
    array: T[],
    key: keyof T,
    value: T[keyof T] | any
  ): T | T[] | null {
    let values: T[] = [];

    for (const obj of array) {
      if (obj[key] === value) {
        values.push(obj);
      }
    }

    if (values.length === 1) {
      return values[0]; // Return the single matched object.
    } else if (values.length > 1) {
      return values; // Return the array of matched objects if more than one.
    }

    return null; // Return null if no matches are found.
  }

  filterKeys(
    originalDict: { [key: string]: any },
    keysToKeep: string[]
  ): { [key: string]: any } {
    const filteredDict: { [key: string]: any } = {};

    keysToKeep.forEach((key) => {
      if (originalDict.hasOwnProperty(key)) {
        filteredDict[key] = originalDict[key];
      }
    });

    return filteredDict;
  }

  splitAndTrim(inputString: string): string[] {
    if (!inputString) {
      return [];
    }

    // Split the string by commas
    const stringArray = inputString.split(',');

    // Trim white spaces from left and right of each element
    const trimmedArray = stringArray.map((element) => element.trim());

    return trimmedArray;
  }

  joinToString(inputArray: string[]): string {
    if (!inputArray || inputArray.length === 0) {
      return '';
    }

    // Join the array elements with commas
    const joinedString = inputArray.join(',');

    return joinedString;
  }

  getAvailableJwtAlgo() {
    const algorithms = ['HS256', 'HS384', 'HS512'];

    return algorithms;
  }
  convertTimeStamp(timeStamp: string) {
    const localTime: any = this.datePipe.transform(
      timeStamp,
      'dd-MMMM-yyyy, HH:mm:ss'
    );
    return localTime;
  }
}
